import { Cookies } from 'react-cookie';

const cookies = new Cookies();

/**
 * TRAD-2003 — 인증 쿠키 보안 기본값.
 * `sameSite: 'lax'` — CSRF·크로스사이트 유출 표면 축소. Strict가 아니라 Lax인 이유:
 *   외부 링크/소셜 OAuth 리다이렉트로 최상위 GET 진입 시에도 로그인이 유지돼야 하기 때문.
 * `path: '/'` — set/remove(removeCookie는 path:'/' 고정) 스코프 정합.
 * secure는 호출측이 환경(https 여부)에 맞게 넘긴 값을 그대로 존중한다(여기서 강제 안 함 —
 * localhost http 개발환경에서 secure 강제 시 쿠키 세팅이 실패하므로).
 * 참고: 현재 API 인증은 Bearer 헤더 방식(JS가 쿠키를 읽어 헤더에 실음, withCredentials 미사용)이라
 * sameSite가 API 인증 자동전송을 끊지 않는다 — 로그인 플로우 회귀 없음.
 */
const DEFAULT_COOKIE_OPTIONS = { sameSite: 'lax', path: '/' } as const;

export const setCookie = (name: string, value: string, options?: Record<string, unknown>) => {
  // 호출측 옵션이 기본값을 덮어쓸 수 있도록 뒤에 병합(예: sameSite/path 커스터마이즈).
  return cookies.set(name, value, { ...DEFAULT_COOKIE_OPTIONS, ...options });
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const removeCookie = (name: string) => {
  cookies.remove(name, { path: '/' });
};
